const orderTypes = {
    CHECKOUT_ORDER_ACTION: "CHECKOUT_ORDER_ACTION",
    CHECKOUT_ORDER_SUCCESS: "CHECKOUT_ORDER_SUCCESS",
    CHECKOUT_ORDER_FAILED: "CHECKOUT_ORDER_FAILED",
    PAYMENT_ORDER_ACTION: "PAYMENT_ORDER_ACTION",
    PAYMENT_ORDER_SUCCESS: "PAYMENT_ORDER_SUCCESS",
    PAYMENT_ORDER_FAILED: "PAYMENT_ORDER_FAILED",
    GET_ORDER_DETAIL_ACTION: "GET_ORDER_DETAIL_ACTION",
    GET_ORDER_DETAIL_SUCCESS: "GET_ORDER_DETAIL_SUCCESS",
    GET_ORDER_DETAIL_FAILED: "GET_ORDER_DETAIL_FAILED",
    CLEAR_ORDER_ACTION: "CLEAR_ORDER_ACTION"
}

export default orderTypes;